import CardWrapper from '../card-wrapper';
import Step03Image from '../../../../../assets/images/memory/onboarding/step-03.svg';
import { Typography } from '../../../../../core/components/molecules/Typography';
import StepButton from '../step-button';
import { Icon } from '../../../../../core/components/atoms/Icon';

const Step03A = ({
  onNextStep,
  onPreviousStep,
}: {
  onNextStep: () => void;
  onPreviousStep: () => void;
}) => {
  return (
    <CardWrapper.Root side='left'>
      <CardWrapper.Primary className='flex flex-col items-center justify-center gap-4 px-5'>
        <div className='flex w-full flex-col items-start justify-center gap-4'>
          <Typography
            title='h1'
            className='!text-h1 font-bold text-mono-color-darker'
          >
            <i>Flashcards</i>
          </Typography>
          <Typography
            title='h3'
            className='!text-h3 font-bold text-mono-color-darker'
          >
            Criando um <i>flashcard</i>
          </Typography>
          <Typography className='!text-md !font-normal text-mono-color-darker'>
            Na área de <i>flashcards</i>. Acesse a disciplina que você irá criar
            seu <i>flashcard</i>.
            <br />
            Ao escolher a disciplina, vá em Criar <i>Flashcards</i>.
          </Typography>
        </div>
        <div className='flex w-full justify-end'>
          <StepButton label='Voltar' onClick={onPreviousStep} type='text' />
          <StepButton
            label='Continuar'
            onClick={onNextStep}
            icon={<Icon Icon={'keyboard_arrow_right'} type='material' />}
          />
        </div>
      </CardWrapper.Primary>

      <CardWrapper.Secondary className='h-[438px] w-[554px]'>
        <img
          src={Step03Image}
          alt='Step 03-A'
          className='h-full w-full rounded-lg md:object-cover'
        />
      </CardWrapper.Secondary>
    </CardWrapper.Root>
  );
};

export default Step03A;
